export default __webpack_public_path__ + "static/media/nordstrom.efcddb7b.svg";